import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { assetUrl } from '../lib/media';

export default function ServiceCard({ service }) {
  const Icon = service.icon;

  return (
    <Link
      to={service.to}
      className="group overflow-hidden border border-brand-gray-200 bg-white transition-transform duration-200 hover:-translate-y-1"
    >
      <div className="relative h-56 overflow-hidden bg-brand-gray-100">
        <img
          src={assetUrl(service.image, 700)}
          srcSet={undefined}
          alt={service.label}
          className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.03]"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(17,17,17,0.05)_0%,rgba(17,17,17,0.35)_100%)]" aria-hidden="true" />
      </div>

      <div className="space-y-4 p-6">
        <div className="flex items-center justify-between gap-4">
          <h3 className="font-display text-2xl font-bold tracking-tight text-brand-black">
            {service.label}
          </h3>
          <ArrowRight className="h-5 w-5 shrink-0 text-brand-orange transition-transform duration-200 group-hover:translate-x-1" />
        </div>
        <p className="text-sm leading-7 text-brand-gray-600">
          {service.description}
        </p>
      </div>
    </Link>
  );
}
